import { createTracker } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import events from '../../events.yaml';
import { getIsAcceptanceTest } from './isAcceptanceTest';

// Docs: https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/anonymous-tracking.html
export const usageTracker = createTracker({
  events,
  properties: {
    deviceId: makeUuid()
  }
});
export const trackInteraction = args => {
  if (getIsAcceptanceTest()) {
    return;
  }
  usageTracker.track('interaction', args);
};
export const trackPageView = args => {
  if (getIsAcceptanceTest()) {
    return;
  }
  usageTracker.track('pageView', args);
};